/**
 * The Diagnostic in Turkish — Kagan and Halil's own copy, not a translation
 * pass by anybody here.
 *
 * A deep partial of `diagnostic.ts`, the same way `content/tr.ts` is a partial
 * of `content/en.ts`: same shape, same option ORDER, Turkish strings.
 *
 * Kudret/Niyet are the axis names Digitopia already uses; they are the original
 * terms rather than translations of Skill/Will, and are left as supplied.
 */

export const diagnosticTr = {
  ui: {
    ax1name: 'Niyet',
    ax2name: 'Kudret',
    ax1q: 'Ne başarmak istediğimiz konusunda net, kararlı ve hizalı mıyız; gerçekten dönüşmek istiyor muyuz?',
    ax2q: 'Bunu gerçekten uygulayacak ve bitirecek operasyonel motora, kapasiteye ve kaynağa sahip miyiz?',
    ax1tag: 'Eksen 1 · Niyet',
    ax2tag: 'Eksen 2 · Kudret',
    ax1card: 'Eksen 1: istek ve kararlılık',
    ax2card: 'Eksen 2: güç ve kapasite',
    ax1items: [
      'Vizyon netliği: tartışmasız bir hedef durum ve başarı metrikleri',
      'Liderlik kararlılığı: inanç, cesaret ve kaynak tahsisi',
      'Kurumsal hizalanma: orta kademede kaybolmayan niyet',
      'Stratejik odak: NE YAPMAYACAĞIMIZ konusunda açık mutabakat',
    ],
    ax2items: [
      'Yetenek & yetkinlik: beceriler, yedek kadro derinliği, alan uzmanlığı',
      'Süreç & yönetişim: karar hakları, teslim disiplini, PMO olgunluğu',
      'Altyapı & teknoloji: platformlar, veri mimarisi, sermaye',
      'Uyarlanabilir kültür: hız, psikolojik güvenlik, dayanıklılık',
    ],
    qcount: '{n} soru · yaklaşık üç dakika',
    back: 'Önceki soru',
    yourprofile: 'Hazırlık profiliniz',
    whatthis: 'Bu pratikte neye benziyor',
    picture: 'Tablo',
    internal: 'Kurum içinde',
    external: 'Pazarın gözünde',
    odds: 'Bu genelde nereye varır',
    imperative: 'Danışmanlık önceliği',
    breakdown: 'Sekiz boyutunuz',
    breakdownsub: 'Ortalama skor darboğazı gizler. Darboğaz aslında burada.',
    risks: 'En yüksek olasılıklı iki başarısızlık moduna dikkat',
    riskssub: 'En zayıf iki boyutunuzdan türetildi ve dönüşüm araştırmalarındaki belgelenmiş başarısızlık kalıplarıyla eşleştirildi.',
    precedent: 'Emsal',
    precedentsub: 'Aşağı yukarı sizin bulunduğunuz yerde duran ve zıt yönlere giden iki kurum.',
    retake: 'Teşhisi tekrarla',
  },
  questions: [
    {
      axis: 'N',
      dim: 'Niyet · Vizyon netliği',
      short: 'Vizyon netliği',
      text: 'Şirket genelinde on kişiyi durdurup bu dönüşümün neyi başarmaya çalıştığını sorsak ne duyardık?',
      options: [
        '“Dijital”, “yapay zekâ”, “verimlilik” gibi genel bir yön var, ama kimsenin ölçebileceği bir hedef durum yok.',
        'Tutarlı tek bir cevap: hedef durum ve oraya vardığımızı kanıtlayacak sayılar dahil.',
        'On farklı cevap; birkaçı iş sonucu yerine bir proje kod adı söylerdi.',
        'Net bir varış noktası, ama başarı işte neyin değişeceğiyle değil, ne inşa edeceğimizle tanımlanmış.',
      ],
    },
    {
      axis: 'N',
      dim: 'Niyet · Liderlik kararlılığı',
      short: 'Liderlik kararlılığı',
      text: 'Dönüşüm bütçe, üst düzey bir rol ya da dokunulmaz bir ürün gibi zor bir ödünleşme dayattığında gerçekte ne oluyor?',
      options: [
        'CEO karar veriyor, genelde de doğru karar veriyor; ama her karar bir mücadeleye mal oluyor ve aylar sürüyor.',
        'Erteleniyor. Dönüşüm kısıta uyum sağlıyor; kısıt asla uyum sağlamıyor.',
        'Ödünleşmeler açıkça ve hızla yapılıyor; isimleri belli liderler sonuçtan bizzat sorumlu tutuluyor.',
        'Bütçesini veriyoruz, ama başarısız olursa kimsenin primi, unvanı ya da yetkisi gerçekten riskte değil.',
      ],
    },
    {
      axis: 'N',
      dim: 'Niyet · Kurumsal hizalanma',
      short: 'Kurumsal hizalanma',
      text: 'Strateji duyurulduktan sonra kurumun orta kademesi nasıl davranıyor?',
      options: [
        'Onu kendi ekiplerinin hedeflerine çeviriyor ve kimse söylemeden insan kaynağını yeniden dağıtmaya başlıyorlar.',
        'Uyum gösteriyorlar. Sunum iletiliyor, dil benimseniyor, davranış aynı kalıyor.',
        'İstekli olanlar harekete geçiyor; geri kalanı kendi operasyonel KPI\'larının arkasına sığınıyor.',
        'Geçmesini bekliyorlar. Çoğu bunun üç örneğini gördü ve dördüncüsünü bekliyor.',
      ],
    },
    {
      axis: 'N',
      dim: 'Niyet · Stratejik odak',
      short: 'Stratejik odak',
      text: 'Bu dönüşüme yer açmak için açıkça neyi yapmayı bıraktık?',
      options: [
        'Hiçbir şeyi. Geçen yılın her şeyi hâlâ listede, bu da onun üstüne eklendi.',
        'Birkaç projeyi kestik, ama en büyük eski taahhütlere hâlâ dokunulamıyor.',
        'Birkaç şeyi “önceliksizleştirdik”, ama ne bütçe ne de kadro gerçekten yer değiştirdi.',
        'İsmi konmuş girişimleri durdurduk ya da elden çıkardık, bunu açıkça söyledik ve insanları yeniden görevlendirdik.',
      ],
    },
    {
      axis: 'K',
      dim: 'Kudret · Yetenek & yetkinlik',
      short: 'Yetenek & yetkinlik',
      text: 'Dönüşümün en kritik üç rolü yarın boşalsa, doldurabilir miydik?',
      options: [
        'Sadece danışman alarak; onlar gittiğinde bilgi de birlikte giderdi.',
        'Evet: bilinçli olarak oluşturduğumuz yedek kadrodan, bir çeyrek içinde, içeriden.',
        'Hayır. O üç rolün ne olduğunu bile güvenle bilmiyoruz.',
        'Dışarıdan alabilirdik, ama uyum ve içeride itibar kazanma bize bir yıla mal olurdu.',
      ],
    },
    {
      axis: 'K',
      dim: 'Kudret · Süreç & yönetişim',
      short: 'Süreç & yönetişim',
      text: 'Üç departmanı birden ilgilendiren bir dönüşüm kararı gerçekte nasıl alınıyor?',
      options: [
        'Karar hakları yazılı. Sorumlu sahip günler içinde karar veriyor; diğerleri bilgilendiriliyor.',
        'Yeterince kıdemli birine ulaşana kadar yukarı taşınıyor ya da yolda sessizce ölüyor.',
        'İlişkiler ve iyi niyetle. Doğru kişiler iyi anlaşıyorsa işliyor.',
        'Bir yürütme kurulu özenle hallediyor, ama aylık bir ritimde.',
      ],
    },
    {
      axis: 'K',
      dim: 'Kudret · Altyapı & teknoloji',
      short: 'Altyapı & teknoloji',
      text: 'Başarılı bir pilot tüm kuruma ölçeklenmesi gerektiğinde ne oluyor?',
      options: [
        'Ölçeklenmiyor. Pilotlarımız, çekirdek sistemlerin konuşamadığı bir kum havuzunda yaşıyor.',
        'Verimizin temiz olduğu yerde ölçekleniyor; bu da aşağı yukarı işin yarısı.',
        'Ortak platformlar ve yönetişimi yapılmış veri üzerinde ölçekleniyor; yaygınlaştırma bütçesi baştan ayrılmış.',
        'Teknik olarak mümkün, ama her yaygınlaştırma kendi başına özel bir entegrasyon projesine dönüşüyor.',
      ],
    },
    {
      axis: 'K',
      dim: 'Kudret · Uyarlanabilir kültür',
      short: 'Uyarlanabilir kültür',
      text: 'Bir dönüşüm girişiminin bir parçası başarısız olduğunda ne oluyor?',
      options: [
        'Dürüstçe raporlanıyor, sonra da hiçbir şey değiştirmeden plana eklemleniyor.',
        'Günler içinde ortaya çıkıyor, açıkça konuşuluyor ve plan dramsız biçimde değişiyor.',
        'İnkâr edilemez hale gelene kadar gizleniyor, sonra biri sessizce başka göreve veriliyor.',
        'Öğreniyoruz, ama yavaş ve genelde ancak çeyreklik değerlendirmede.',
      ],
    },
  ],
  archetypes: {
    PIPE: {
      name: 'Hayal Tacirleri',
      tag: '“Hep direksiyon, hiç motor.”',
      sub: 'Yüksek Niyet · Düşük Kudret',
      picture: 'Bisiklet iskeletine cıvatalanmış şık, fütüristik bir kokpit. Yönetim toplantıları beş yıllık vizyonlarla dolu, rengârenk parlak strateji sunumları üretiyor. Toplantı odası enerjik, ama sahada hiçbir şey kımıldamıyor.',
      internal: 'Ekipler sürekli yangın söndürmeye hapsolmuş. KPI\'lar çeyrek çeyrek kaçırılıyor; bu da girişim yorgunluğu, sinizm ve en iyi insanlarda yüksek devir yaratıyor; bu insanlar hedefi vuracak araç ve bütçe olmadan hareketli hedef kovalamaktan tükenmiş durumda.',
      external: 'Pazar ve müşteriler cesur vaatler ve duyurular duyuyor, ardından teslimat gecikmeleri, kalite kırılmaları ve tutulmayan sözlerle karşılaşıyor. İtibar, stratejinin revize edilebileceğinden daha hızlı eriyor.',
      odds: 'İki yol var. Ya kudret açığı 12–18 ay içinde kapanır ve hırs hayatta kalır; ya da üçüncü kaçırılan kilometre taşı kurumun niyetini sinizme çevirir ve başladığınızdan daha kötü bir konumla Sürüklenenler çeyreğine düşersiniz.',
      impT: 'Motoru inşa edin',
      impP: 'Yeni strateji yazmayı bırakın. Vizyona harcanan her saatin artık getirisi negatif. Tüm eforu PMO yönetişimine, süreç mühendisliğine, platform ve veri yatırımına ve hedefli yetenek kazanımına yönlendirin. Teslim kapasitesinin gözle görülür şekilde arttığı kanıtlanana kadar girişim portföyünü mevcut boyutunda dondurun.',
      cases: [
        'GE',
        'DBS',
      ],
    },
    UNSTOP: {
      name: 'Durdurulamazlar',
      tag: '“Tam hızda hassasiyet.”',
      sub: 'Yüksek Niyet · Yüksek Kudret',
      picture: 'Uzman bir yol göstericiyle sürülen yüksek performanslı bir Formula 1 aracı. Her viraj hesaplanmış, pit ekibi milisaniye hassasiyetinde çalışıyor ve araç her stratejik hedefe pürüzsüzce hızlanıyor.',
      internal: 'Yüksek güven, psikolojik güvenlik ve yoğun hesap verebilirlik bir arada. Kararlar hızlı, çünkü ekipler hem stratejik niyeti hem de kendi yetki sınırlarını biliyor. Sonuçlar her planlama döngüsünde sıfırlanmak yerine yıldan yıla birikiyor.',
      external: 'Sektör lideri ya da kategori tanımlayan yenilikçi. Rakipler gündemi belirlemek yerine hamlelerinize savunmacı tepki veriyor ve birinci sınıf yetenek aranmadan başvuruyor.',
      odds: 'Asıl risk artık uygulama değil; rehavet ve ufuk körlüğü. Bu çeyrekteki kurumlar konumlarını çoğu zaman bir emsale değil, rakip saymadıkları bir iş modeline kaptırır.',
      impT: 'Ölçekleyin ve koruyun',
      impP: 'Dikkati Ufuk 2 ve 3 inovasyonuna, kurumsal risk yönetimine, savunma hendeği inşasına ve siyah kuğu şoklarına karşı kurumsal dayanıklılığa kaydırın. Şu anda belirli kişilere bağlı olanı kurumsallaştırın ki bugünkü performans yarınki liderlik değişimini atlatsın.',
      cases: [
        'DBS',
        'DEERE',
      ],
    },
    DRIFT: {
      name: 'Sürüklenenler',
      tag: '“Ne harita var ne ivme.”',
      sub: 'Düşük Niyet · Düşük Kudret',
      picture: 'Ne küreği ne pusulası olan, sisli bir gölde sürüklenen bir kayık. Mürettebat boş oturuyor; yalnızca gövdeden su sızdığında ya da ani bir dalga tekneyi salladığında tepki veriyor.',
      internal: 'Bürokratik felç, ilgisizlik ve düşük moral. İnsanlar statükoyu korumak için gereken asgariyi yapıyor. Siloler derinlemesine yerleşmiş ve inovasyon bir fırsat değil, istenmeyen bir rahatsızlık olarak yaşanıyor.',
      external: 'İlgisiz ya da gözle görülür şekilde geriliyor. Pazar şirketi, daha çevik meydan okuyuculara istikrarlı biçimde pay kaptıran eski bir kalıntı olarak okuyor ve giderek öyle fiyatlıyor.',
      odds: 'Bu çeyrek kendini düzeltmez. Dışarıdan müdahale olmadan tipik seyir, yavaş bir marj erimesi ve ardından bir kırılma noktasıdır: bir regülasyon değişikliği, bir teknoloji sıçraması ya da kararı elinizden alan bir satın alma.',
      impT: 'Dönüş müdahalesi',
      impP: 'Bu bir dönüşüm programı değil, bir toparlanma operasyonudur. Sıralama: önce liderlik yeniden hizalanması, sonra stratejik yeniden konumlanma, sonra varlık rasyonalizasyonu, sonra çekirdek operasyonel yeniden yapılanma. Liderlik sorusu çözülmeden kudret inşasına girişmek, hem bütçeyi hem de kalan iyi niyeti güvenilir biçimde harcar.',
      cases: [
        'FORD',
        'DEERE',
      ],
    },
    BLIND: {
      name: 'Kudretli Körler',
      tag: '“Motor tam güç, pusula bozuk.”',
      sub: 'Düşük Niyet · Yüksek Kudret',
      picture: 'Raylarda azami hızla ilerleyen bir yük treni; ileride köprünün hâlâ ayakta olup olmadığını kimse kontrol etmiyor.',
      internal: 'Değer yaratımından kopmuş hiper-verimli faaliyet. Ekipler, artık pazar talebiyle ya da kurumsal hedeflerle örtüşmeyen çıktılar için fazla mesai yapıyor. Meşguliyet mükemmelleştirilmiş; ciro büyümesi yatay.',
      external: 'Dünün çözümlerini teslim etmekte son derece güvenilir. Müşteriler operasyonel disipline saygı duyuyor, ama geleceğe dönük bir değer önerisi sunan rakiplere geçiyor.',
      odds: 'En tehlikeli çeyrek, çünkü göstergeler yeşil görünüyor. Yanlış hedefe çevrilmiş kudret yavaş ve görünmez biçimde çürür; sorun kâr-zarar tablosunda göründüğünde, gurur duyduğunuz motor artık var olmayan bir pazara göre optimize edilmiş olur.',
      impT: 'Enerjiyi yeniden yönlendirin',
      impP: 'Daha fazla kudrete ihtiyacınız yok; pusulaya ihtiyacınız var. Yenilenmiş bir vizyon üzerinde sert bir üst yönetim hizalanması yapın, portföyü açıkça budayın ve teşvikleri faaliyet metriklerinden (devreye alma hızı, teslim edilen proje sayısı) değer metriklerine (FAVÖK etkisi, çevrim süresi, müşteri sonucu) yeniden bağlayın. Hâlihazırda sahip olduğunuz motor, herhangi bir yeni programdan daha değerlidir.',
      cases: [
        'FORD',
        'DEERE',
      ],
    },
  },
  cases: {
    GE: {
      kind: 'fail',
      name: 'General Electric: Predix',
      p: 'GE, bir üretim devini yazılım platformuna dönüştürmesi beklenen endüstriyel IoT işletim sistemi Predix\'i geliştirmek için GE Digital\'i kurdu. Havacılık, Sağlık ve Enerji genelinde net bir değer önerisi ya da kudret temeli oluşturulmadan yazılıma milyarlarca dolar aktı. İş birimleri platformu istemedi; GE Digital sermayeyi tüketti ve sonunda ayrıştırıldı, bu da şirketin bölünmesine katkıda bulundu.',
      l: 'Yüksek niyet, sıfır kudret hizalanması. Bir yazılım iş modeli, altındaki kudret dönüştürülmeden bir donanım kurumuna dayatıldı.',
    },
    FORD: {
      kind: 'fail',
      name: 'Ford: Smart Mobility',
      p: 'Ford, bağlantılı araçlar ve araç paylaşımı için üretim hatlarından ayrı, bağımsız bir birim olarak Ford Smart Mobility\'yi kurdu. Dönüşüm ekibini Silikon Vadisi\'nde izole etmek kültürel bir yarık yarattı: çekirdek iş birimi pahalı bir dikkat dağıtıcı olarak gördü, birim ise çekirdek operasyonları etkileyemedi. Sonuç büyük değer düşüklükleri, hisse durgunluğu, bir CEO\'nun ayrılışı ve dijitalin sonunda ana işe geri entegre edilmesi oldu.',
      l: 'Siloda dönüşüm. Eski operasyon genelinde hizalanmış niyet olmadan kudret, değişim değil hareket üretir.',
    },
    DBS: {
      kind: 'win',
      name: 'DBS Bank: “Dünyanın En İyi Dijital Bankası”',
      p: '2000\'lerin sonunda DBS Singapur yavaş hizmeti ve düşük müşteri memnuniyetiyle biliniyordu. CEO Piyush Gupta yönetiminde banka Google, Amazon, Netflix, Apple, LinkedIn ve Facebook gibi davranmayı hedefledi; hazır yazılım satın almak yerine kendi mimarisini mikroservisler ve API\'ler üzerine yeniden kurarken 20.000\'den fazla çalışanı çevik ve tasarım odaklı düşünme konusunda eğitti.',
      l: 'Derin operasyonel kudretle eşleşen yüksek niyet. Defalarca dünyanın en iyi bankası seçildi; maliyet/gelir oranı ve özkaynak kârlılığı emsallerinin belirgin şekilde önünde.',
    },
    DEERE: {
      kind: 'win',
      name: 'John Deere: hassas tarım',
      p: 'Geleneksel traktör satışlarında doygunlukla karşılaşan 180 yıllık bir ekipman üreticisi, kendisini bir hassas tarım teknoloji platformuna dönüştürdü: makinelere gömülü IoT sensörleri, bilgisayarlı görü ve yapay zekâ, Operations Center üzerinden sunuldu. Kritik olan şu: Deere bayi ağını çiftçilere veriye dayalı tarımı öğretecek şekilde geliştirdi ve bayi teşviklerini yazılım benimsemesiyle hizaladı.',
      l: 'Yalnızca teknolojiyi değil, iş modelini ve kudreti dönüştürün. Deere artık donanımın yanında SaaS abonelik ücreti alıyor ve gerçek bir yazılım hendeğine sahip.',
    },
  },
}
